import FormErrorModel from './form-error.model';

class SettingsFormModel {
  constructor() {
    // values can be username and password only.
    this.type = 'username';

    this.newUsername = '';
    this.confirmNewUsername = '';

    this.newPassword = '';
    this.confirmNewPassword = '';

    this.currentPassword = '';

    this.error = new FormErrorModel();
  }

  get isUsername() {
    return this.type === 'username';
  }

  get isPassword() {
    return this.type === 'password';
  }

  get isTransaction() {
    return this.type === 'transaction';
  }

  setFormErrors(errors) {
    this.error.setFormErrors(errors);
  }

  toPayload() {
    let payload = {
      security: {
        currentPassword: this.currentPassword,
      }
    };

    if (this.isUsername) {
      payload['security']['hasChangeUsername'] = true;
      payload['security']['username'] = {};
      payload['security']['username']['first'] = this.newUsername;
      payload['security']['username']['second'] = this.confirmNewUsername;
    } else {
      payload['security']['hasChangePassword'] = true;
      payload['security']['password'] = {};
      payload['security']['password']['first'] = this.newPassword;
      payload['security']['password']['second'] = this.confirmNewPassword;
    }

    return payload;
  }

  reset() {
    this.type = 'username';

    this.newUsername = '';
    this.confirmNewUsername = '';

    this.newPassword = '';
    this.confirmNewPassword = '';

    this.currentPassword = '';
  }
}

export default SettingsFormModel;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/settings/model/form.model.js